module.exports = __webpack_public_path__ + "static/media/popular1.143d18dc.png";